import React from 'react';
import {formatCount} from './format';
import './charts.css';

/*
 * The hover bubble, for every chart on the page.
 *
 * There were two of these before, one copied from the other, both drawing a
 * white box with a #ccc border - which is a white box on a dark ground in the
 * dark theme. This one is painted from tokens like everything else.
 *
 * recharts hands it `payload`: one entry per series under the cursor, each
 * carrying its own colour, so the swatch matches the slice being pointed at
 * without the caller passing anything.
 */
const ChartTooltip = ({active, payload, label, labelFormatter, nameFormatter, valueFormatter}) => {
    if (!active || !payload || !payload.length) return null;

    const head = labelFormatter ? labelFormatter(label) : label;

    return (
        <div className="chart-tooltip">
            {head ? <div className="chart-tooltip__head">{head}</div> : null}

            {payload.map((entry, index) => {
                /* a stacked bar puts every series in the payload, including
                   the ones sitting at zero for this bar - they say nothing.
                   Compared as a number: a count can arrive as the string "0" */
                if (!Number(entry.value)) return null;

                const name = nameFormatter ? nameFormatter(entry.name, entry) : entry.name;
                const color = entry.color || (entry.payload && entry.payload.fill);

                return (
                    <div className="chart-tooltip__row" key={index}>
                        <span className="chart-tooltip__swatch" style={{backgroundColor: color}}/>
                        <span>{name}</span>
                        <span className="chart-tooltip__value">
                            {valueFormatter ? valueFormatter(entry.value) : formatCount(entry.value)}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default ChartTooltip;



// WEBPACK FOOTER //
// ./src/components-new/general/charts/ChartTooltip.jsx